import { Component, OnInit, Injector } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ModalBaseComponent } from '../modal-base-component';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.css']
})
export class SuccessModalComponent extends ModalBaseComponent {

  successMessage: string;

  constructor(inject: Injector,private _bsModalRef: BsModalRef) {
    super(inject);
  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/success-modal/success-modal.component.ts